import { render, staticRenderFns } from "./PurchaseClientQuestionnaire.vue?vue&type=template&id=5fcfda4c&"
import script from "./PurchaseClientQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./PurchaseClientQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports